import React, { useState } from 'react'
import FormPlateInput from 'parkdepot-shared/components/LPInput'
import { useStyletron } from 'parkdepot-shared/theme'
import Text from '@components/style/Text.style'
import Button from 'parkdepot-shared/components/Buttons/Button'
import { BUTTON_SIZE } from 'parkdepot-shared/components/Buttons'
import { useGetUser } from '@hooks/useAuth'
import useLazyGetOpenOrders from '@hooks/useLazyGetOpenOrders'
import { useHistory, useLocation } from 'react-router-dom'
import HelpDrawer from './components/HelpDrawer.component'

import { Container, Link } from './Home.style'
import carpayLPNotFoundRoute from '../NotFound/route.const'
import { useTranslation } from 'react-i18next'
import { getDomainExtension, getLanguageBasedOnDomain } from '@utils/getDomainExtension'
import carpayOrderListRoute from '../OrderList/route.const'
import { SeoHead } from '@components/SeoHead/SeoHead.component'

const CarpayHome = () => {
    const { t, i18n } = useTranslation()
    const seoLang = i18n.getFixedT(getLanguageBasedOnDomain())
    const { user } = useGetUser()
    const location = useLocation()
    const [, theme] = useStyletron()
    const history = useHistory()
    const [isHelpDrawerOpen, setIsHelpDrawerOpen] = useState(false)
    const queryparams = new URLSearchParams(location.search)
    const [country, setCountry] = useState<string>(() => {
        const domain = getDomainExtension()
        if (!user || user.license_plates.length === 0) return domain === 'com' ? 'INT' : domain.toUpperCase()

        return user.license_plates[0].country
    })
    const [plate, setPlate] = useState<string>(() => {
        if (!user || user.license_plates.length === 0) return ''

        return user.license_plates[0].plate
    })
    const [getOrders, { loading }] = useLazyGetOpenOrders({
        onCompleted: (data) => {
            if (!data.b2c_get_open_orders.orders.length) {
                // Error flow in future?
                return history.push(
                    `${carpayLPNotFoundRoute}?country=${country}&plate=${plate}&${queryparams.toString()}`
                )
            }

            history.push(`${carpayOrderListRoute}?country=${country}&plate=${plate}&${queryparams.toString()}`)
        }
    })

    const disableButton = !plate

    return (
        <>
            <SeoHead title={seoLang('seo.pages.payTitle')} description={seoLang('seo.pages.payDescription')} />

            <Container
                onKeyDown={(e) => {
                    if (!disableButton && e.key === 'Enter') {
                        getOrders({ variables: { plates: [plate] } })
                    }
                }}
            >
                <Text typography={theme.typography.HeadingXLarge} $align="center" fontWeight={700}>
                    {t('carpay.home.title')}
                </Text>

                <FormPlateInput
                    width="100%"
                    value={plate}
                    country={country}
                    onChange={(val) => setPlate(val)}
                    onCountryChange={(val) => setCountry(val)}
                    overrides={{
                        DropdownButton: {
                            height: '52px'
                        },
                        DropdownFlag: {}
                    }}
                />

                <Button
                    id="home-search-button"
                    onClick={() => getOrders({ variables: { plates: [plate] } })}
                    isLoading={loading}
                    disabled={loading || disableButton}
                    overrides={{ BaseButton: { style: { width: '100%' } } }}
                    $size={BUTTON_SIZE.medium}
                >
                    {t('carpay.home.search')}
                </Button>

                <Link role="button" onClick={() => setIsHelpDrawerOpen((open) => !open)}>
                    {t('carpay.home.help')}
                </Link>

                <HelpDrawer isOpen={isHelpDrawerOpen} onClose={() => setIsHelpDrawerOpen(false)} />
            </Container>
        </>
    )
}

export default CarpayHome
